import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FondoOnere } from '../../../models/fondo-onere';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneEconomicaFondoOneriUpdateComponent } from './sezione-economica-fondo-oneri-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-fondo-oneri-update]',
  templateUrl: 'sezione-economica-mod-fondo-oneri-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SezioneEconomicaFondoOneriModUpdateComponent {
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formFondoOneriUpdate') formFondoOneri: SezioneEconomicaFondoOneriUpdateComponent;

  inizializza(sezione: SezioneEconomica, fondoOnere: FondoOnere, fascicolo: FascicoloFull, urlUpdate: string, urlReadSezioneEconomica: string, urlReadSezioneLegali: string) {
    this.formFondoOneri.inizializza(sezione, fondoOnere, fascicolo, urlUpdate, urlReadSezioneEconomica, urlReadSezioneLegali);
    openModal('modaleFondoOneriUpdate');
  }

  createForm() {
    this.formFondoOneri.createForm();
  }

  manageModal(sezioneEconomica: SezioneEconomica) {
      closeModal('modaleFondoOneriUpdate');
      this.onReturn.emit(sezioneEconomica);
  }
}
